import { FC } from 'react';

import { IconProps } from '../types';

export const WhatsApppIcon: FC<IconProps> = ({
	size,
	height = 18,
	width = 18,
	color = '#06519E',
}) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 18 18"
		width={size ?? width}
		height={size ?? height}
	>
		<path
			fill={color}
			fillRule="evenodd"
			d="m3.335 15.99 1.28-.229.776-.137A7.43 7.43 0 0 0 9 16.538c4.157 0 7.538-3.38 7.538-7.538 0-4.157-3.38-7.538-7.538-7.538-4.157 0-7.538 3.38-7.538 7.538 0 1.508.457 2.878 1.188 4.066l-.092.685-.182 1.37-.137 1.052 1.096-.183ZM9 0c4.98 0 9 4.02 9 9s-4.02 9-9 9c-1.37 0-2.65-.274-3.792-.822L.411 18l.64-4.751-.046-.092A9.012 9.012 0 0 1 0 9c0-4.98 4.02-9 9-9ZM5.802 4.888c.503-.32.822-.091 1.005.411l.457 1.188s.32.64-.503 1.28c-.137.09-.137.09-.09.32.182.547.913 2.192 3.243 3.471.228.137.274.137.502-.045l.594-.594c.411-.366.64-.503 1.005-.229.274.183.548.412.823.594.274.229.73.503.274 1.051l-.412.503c-.593.73-1.096.776-1.873.593-2.97-.776-5.162-2.878-6.121-5.847-.32-1.142.137-2.102 1.096-2.696Z"
		/>
	</svg>
);
